module.exports = __webpack_public_path__ + "static/media/twealthCourt56.573c70eb.png";